export default "__VITE_ASSET__ClnmXAbU__"